import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsentropicFlowComponent } from './isentropic-flow/isentropic-flow.component';


import { MatTabsModule } from '@angular/material/tabs';
import { IfMachComponent } from './if-mach/if-mach.component';
import { IfPptComponent } from './if-ppt/if-ppt.component';
import { IfTttComponent } from './if-ttt/if-ttt.component';
import { IfAasComponent } from './if-aas/if-aas.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconButton } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { IfPaptasComponent } from './if-paptas/if-paptas.component';
import { IfMachangComponent } from './if-machang/if-machang.component';


@NgModule({
  declarations: [
    IsentropicFlowComponent,
    IfMachComponent,
    IfPptComponent,
    IfTttComponent,
    IfAasComponent,
    IfPaptasComponent,
    IfMachangComponent
  ],
  imports: [
    MatRadioModule,
    CommonModule,
    MatTabsModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    
    
  ],
  exports: [
    IsentropicFlowComponent,
    IfMachComponent
  ]
})
export class IsentropicFlowMdlModule { }
